import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const pMethods = await dataProvider.getList("payment-methods", {});
        setPaymentMethods(pMethods.data);
        return setLoading(false);
      } catch (error) {
        setError(error);
        return setLoading(false);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { paymentMethods, loading, error };
};
export default usePaymentMethods;
